// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EmptyCart_wrapper__1o5JS","emptyCart":"EmptyCart_emptyCart__2J1Hy"};